// extracted by mini-css-extract-plugin
export default {"rotate_hover":"xCloseIcon_rotate_hover__io3bl"};